module.exports = __webpack_public_path__ + "img/symbol_0.ad3b4dfe.png";